import { createFileRoute } from "@tanstack/react-router";
import Dashboard from "@/components/Dashboard";

function RouteComponent() {
  return <Dashboard />;
}

export const Route = createFileRoute("/_authenticated/")({
  component: RouteComponent,
  staticData: { page: "overview" },
});
